import { AtomKey } from '../_constants';
import { GlobalProcessContext } from '@src/responsive/globalProcess/context';
import { atom } from 'recoil';

export const globalProcessState = atom<GlobalProcessContext | null>({
  key: AtomKey.GLOBAL_PROCESS,
  default: null,
});
